import { h } from "preact";

import IconProps from "./IconProps";

function IconGitlab({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? "var(--icon-color, #FC6D26)";
    const secondaryFill = color ?? "var(--icon-color, #E24329)";
    const tertiaryFill = color ?? "var(--icon-color, #FCA326)";

    return (
        <svg class={cssClass} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={secondaryFill} d="m15.659 6.45-.022-.056L13.48.767a.562.562 0 0 0-.558-.353.578.578 0 0 0-.324.121.577.577 0 0 0-.191.29L10.952 5.28H5.058L3.602.826a.566.566 0 0 0-1.073-.06L.369 6.39l-.022.057a4.003 4.003 0 0 0 1.328 4.627l.008.006.02.014 3.284 2.46 1.624 1.229.99.747a.666.666 0 0 0 .805 0l.99-.747 1.624-1.23 3.304-2.474.009-.007a4.005 4.005 0 0 0 1.326-4.621z"/>
            <path fill={fill} d="m15.659 6.45-.022-.056c-1.05.215-2.04.66-2.9 1.303l-4.734 3.58c1.612 1.22 3.016 2.28 3.016 2.28l3.304-2.475.008-.006A4.006 4.006 0 0 0 15.66 6.45z"/>
            <path fill={tertiaryFill} d="m4.986 13.556 1.625 1.23.99.747a.666.666 0 0 0 .805 0l.99-.747 1.624-1.23s-1.405-1.063-3.018-2.28c-1.612 1.217-3.016 2.28-3.016 2.28z"/>
            <path fill={fill} d="M3.267 7.697A7.273 7.273 0 0 0 .37 6.39l-.022.057a4.003 4.003 0 0 0 1.328 4.627l.008.006.02.014 3.284 2.46 3.016-2.28-4.736-3.577z"/>
        </svg>
    );
}

export default IconGitlab;
